import React, { useState } from "react";
import { laneColor, ownerGroupText } from "./fusionApi";

const CHIP = "inline-flex items-center gap-1.5 text-xs px-2.5 py-1 rounded-lg border border-border bg-theme-secondary mr-1.5 mb-1.5";

/**
 * "What may break" (FUSION.md §4.8): the chain's reach, one chip per object group in API order. A group
 * with items expands to its items, each of which re-anchors the chain; the "Findings" group has no
 * items and is a plain count. An item with group owners (an AI agent) shows one muted line per group.
 */
const FusionReach = ({ reach, onOpen }) => {
  const [expanded, setExpanded] = useState(null);
  if (!reach || !reach.groups || reach.groups.length === 0) return null;

  const openGroup = reach.groups.find((g) => g.type === expanded && g.items?.length > 0);

  return (
    <div className="mb-2.5">
      <div className="text-xs font-semibold text-content-secondary mb-2">
        What may break · {reach.affectedTotal} objects across {reach.domainCount} domains
      </div>
      <div>
        {reach.groups.map((g) => {
          const items = g.items || [];
          const dot = <span className="w-2 h-2 rounded-full" style={{ background: items.length > 0 ? laneColor(items[0]?.lane) : "#6b7280" }} />;
          if (items.length === 0) return (
            <span key={g.type} className={`${CHIP} text-content-secondary`}>{dot}{g.count} {g.label}</span>
          );
          return (
            <button key={g.type} type="button" aria-expanded={expanded === g.type}
              onClick={() => setExpanded((e) => (e === g.type ? null : g.type))}
              className={`${CHIP} hover:border-indigo-200 ${expanded === g.type ? "border-indigo-200 text-indigo-700" : ""}`}>
              {dot}{g.count} {g.label}
            </button>
          );
        })}
      </div>
      {openGroup && (
        <div className="rounded-lg border border-border bg-theme-secondary p-2 mt-1">
          {openGroup.items.map((item) => (
            <button key={`${item.type}:${item.id}`} type="button" onClick={() => onOpen(item.type, item.id)}
              className="w-full flex items-center gap-2 text-left text-sm rounded px-2 py-1 hover:bg-theme-hover">
              <span className="w-2 h-2 rounded-full shrink-0" style={{ background: laneColor(item.lane) }} />
              <span className="min-w-0 flex flex-col">
                <span>{item.label}</span>
                {(item.ownerGroups || []).map((g) => {
                  const text = ownerGroupText(g);
                  return <span key={`${g.label}:${g.role}`} className="text-xs text-content-muted truncate" title={text}>{text}</span>;
                })}
              </span>
            </button>
          ))}
          {openGroup.count > openGroup.items.length && (
            <div className="text-xs text-content-muted px-2 py-1">and {openGroup.count - openGroup.items.length} more</div>
          )}
        </div>
      )}
    </div>
  );
};

export default FusionReach;
